import { render, staticRenderFns } from "./TopUpRewards.vue?vue&type=template&id=56152c91"
import script from "./TopUpRewards.vue?vue&type=script&lang=js"
export * from "./TopUpRewards.vue?vue&type=script&lang=js"
import style0 from "./TopUpRewards.vue?vue&type=style&index=0&id=56152c91&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports